import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "patient-roster-field-discrepancy"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'PatientRosterFieldDiscrepancy',
    props: {
        field: {},
        entry: {},
        loading: { type: Boolean },
        error: {}
    },
    emits: ["apply"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_alert = _resolveComponent("v-alert");
            return (__props.entry)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_chip, {
                        size: "small",
                        variant: "tonal",
                        label: "",
                        color: __props.entry.status === 'conflict' ? 'warning' : 'info',
                        "prepend-icon": "mdi-alert-circle-outline"
                    }, {
                        default: _withCtx(() => [
                            (__props.entry.status === 'conflict')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("Patient list has: " + _toDisplayString(__props.entry.rosterValue), 1)
                                ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("Not on the patient list record yet")
                                ], 64))
                        ]),
                        _: 1
                    }, 8, ["color"]),
                    _createVNode(_component_v_btn, {
                        size: "small",
                        variant: "tonal",
                        color: __props.entry.status === 'conflict' ? 'warning' : 'info',
                        "prepend-icon": "mdi-check",
                        loading: __props.loading,
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('apply', __props.field)))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.entry.status === "conflict" ? "Update patient list" : "Save to patient list"), 1)
                        ]),
                        _: 1
                    }, 8, ["color", "loading"]),
                    (__props.error)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            density: "compact",
                            variant: "tonal",
                            color: "error",
                            icon: "mdi-alert-outline",
                            role: "alert"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.error), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
